import apis from 'api/index';

const actions = {
  /**
   * 获取用户的信息和用户权限
   * @param commit
   */
  async fetchBaseInfo({ commit }) {
    const res = await apis.getMyInfo();
    commit('setUserAllInfo', res);
  },
  async fetchDictTree({ commit }) {
    const res = await apis.getDictTree();
    commit('setDictTree', res);
  },
  // 修改购物车里的值
  changeValueOfShop({ commit, state }, product) {
    let shopData = state.shoppingCart;
    let index = shopData.findIndex(item => item.id === product.id);
    shopData[index] = product;
    commit('changeShoppingCart', shopData);
  },
  // 总购物车删除
  deleteValueOfShop({commit, state}, product) {
    let shopData = state.shoppingCart;
    let index = shopData.findIndex(item => item.id === product.id);
    shopData.splice(index, 1);
    commit('changeShoppingCart', shopData);
  }
}

export default actions
